import React, { Component } from 'react'
import PropTypes from 'prop-types'
import cx from 'classnames'

import './style.scss'

export default class CloseableRow extends Component {
    static propTypes = {
        children: PropTypes.element.isRequired,
        expanded: PropTypes.bool,
        expandOnTitleClick: PropTypes.bool,
        id: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
        onExpand: PropTypes.func,
        title: PropTypes.oneOfType([PropTypes.element, PropTypes.string]).isRequired,
    }

    static defaultProps = {
        expanded: false,
        expandOnTitleClick: false,
        id: null,
        onExpand: () => {},
    }

    onClickHandler = (_e) => {
        const { expanded, id, onExpand } = this.props

        onExpand(!expanded, id, _e)
    }

    render() {
        const { title, expanded, expandOnTitleClick, children } = this.props

        return (
            <div className={'closeable-row'}>
                <div className={cx('closeable-row-anchor', expanded && 'expanded')}>
                    <div className={'closeable-row-anchor-border'} />
                    <div className={'closeable-row-anchor-arrow'} onClick={this.onClickHandler} />
                    <div className={'closeable-row-anchor-bottom'} />
                </div>
                <div className={'closeable-row-content'}>
                    <div
                        className={cx('closeable-row-title', expandOnTitleClick && 'clickable')}
                        onClick={expandOnTitleClick && this.onClickHandler}
                    >
                        {title}
                    </div>
                    {expanded && <div className={'closeable-row-children'}>{children}</div>}
                </div>
            </div>
        )
    }
}
